// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3s__Y","description":"PatientConsentPreview_description__1Pm8f"};